import $ from 'jquery';
import UI from './0-ui';
import {is_function} from '../../Helpers/js/simple.functions';

// ----------- //
// DIALOG TABS //
// ----------- //
UI.Dialog.Tabs = {
  params: null,
  initialize: false,
  tabPanel: null,

  init: function (selector, params) {
    var dialog = UI.Dialog.getInstance();
    var root = dialog.parent();

    UI.Dialog.Tabs.storedText = '';
    UI.Dialog.Tabs.params = params;
    UI.Dialog.Tabs.params.selector = selector;

    var tabPanel = $(UI.Dialog.Tabs.params.name);

    var tabParams = {
      loadTabContent: function (tab, panel, callback) {
        var a = tab.find('a');
        if (a.attr('url')) {
          panel.timedLoader(0);
          window.Browser.loadHTML(panel, a.attr('url'), a.attr('url_params'), function () {
            panel.timedLoader(false);
            is_function(callback) && callback();
          });
        } else {
          is_function(callback) && callback();
        }
      },
      //jQuery UI Tabs event "beforeActivate" - It is used to trigger when the tab is going to be active
      beforeActivate: function (event, ui) {
        var result = UI.Dialog.Tabs.beforeTabChanged(ui, false);

        if (result) {
          tabParams.loadTabContent(ui.newTab, ui.newPanel, function () {
            UI.Dialog.Tabs.afterTabLoaded(ui);
          });
        }

        return result;
      },
      activate: function () {
        $('#tabname').val(UI.Dialog.Tabs.getCurrentTabName());
      },
      create: function (event, ui) {
        tabParams.activate(event, ui); //jquery does not call
        tabParams.loadTabContent(ui.tab, ui.panel, function () {
          UI.Dialog.Tabs.afterTabLoaded(ui);
        });
      },
    };

    UI.Dialog.Tabs.tabPanel = tabPanel.tabs(tabParams); //.tabs('option','selected',0);

    if (!params.vertical) {
      // Tabs in den Titel ziehen und Dialog beweglich machen
      $(root).addClass('ui-tabs').prepend($(selector)).draggable('option', 'handle', selector);
    }
  },

  beforeTabChanged: function (ui, refreshOnly) {
    if (UI.Dialog.isClosing) {
      return false;
    } // prevent if Dialog is closing

    if (is_function(UI.Dialog.Tabs.params.beforeTabChanged)) {
      return UI.Dialog.Tabs.params.beforeTabChanged(ui, refreshOnly) ? true : false;
    }

    return true;
  },

  afterTabLoaded: function (ui) {
    if (is_function(UI.Dialog.Tabs.params.afterTabChanged)) {
      UI.Dialog.Tabs.params.afterTabChanged(ui);
    }

    $('.tabError').hide();

    var tabName = UI.Dialog.Tabs.getCurrentTabName();

    if (is_function(UI.Dialog.Tabs.params.onTabLoaded)) {
      UI.Dialog.Tabs.params.onTabLoaded(ui, tabName);
    }

    return true;
  },

  getTab: function (index) {
    var dialog = UI.Dialog.getInstance();
    var root = dialog.parent();

    return $('ul.' + UI.Dialog.Tabs.params.selector + ' li:eq(' + index + ')', root);
  },

  getCurrentTab: function () {
    var dialog = UI.Dialog.getInstance();
    var root = dialog.parent();

    return $('.ui-tabs-active', root);
  },

  getCurrentTabName: function () {
    var tab = UI.Dialog.Tabs.getCurrentTab();
    return $('a', tab).attr('name');
  },

  getCurrentTabText: function () {
    var tab = UI.Dialog.Tabs.getCurrentTab();
    return $('a', tab).html();
  },

  setCurrentTabText: function (text) {
    var tab = UI.Dialog.Tabs.getCurrentTab();
    var anchor = $('a', tab);
    anchor.html(text);
  },

  getCurrentTabIndex: function () {
    return UI.Dialog.Tabs.tabPanel.tabs('option', 'selected');
  },

  selectTab: function (index) {
    var tab = UI.Dialog.Tabs.getTab(index);
    $('a', tab).click();
  },

  getTabText: function (index) {
    return $('a', UI.Dialog.Tabs.getTab(index)).html();
  },

  setTabText: function (index, text) {
    var anchor = $('a', UI.Dialog.Tabs.getTab(index));
    UI.Dialog.Tabs.storedText = anchor.html();
    anchor.html(text);
  },

  restoreTabText: function (index) {
    if (UI.Dialog.Tabs.storedText) {
      var anchor = $('a', UI.Dialog.Tabs.getTab(index));
      anchor.html(UI.Dialog.Tabs.storedText);
    }
  },

  saveCurrent: function (refreshOnly) {
    var tabs = $(UI.Dialog.Tabs.params.name).tabs();
    var current = tabs.tabs('option', 'selected');

    var ui = {
      index: current,
      tab: tabs,
      panel: 0,
    };
    return UI.Dialog.Tabs.beforeTabChanged(ui, refreshOnly);
  },

  reloadCurrent: function () {
    var tabs = $(UI.Dialog.Tabs.params.name).tabs();
    var current = tabs.tabs('option', 'selected');
    tabs.tabs('load', current);

    if (is_function(UI.Dialog.Tabs.params.onTabLoaded)) {
      UI.Dialog.Tabs.params.onTabLoaded();
    }
  },
};
